var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1727 7.5167L11.92 7.4707L11.6487 14.886L12.9013 14.932L13.1727 7.5167Z",
    fill: "#455079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 7.49316H9.49667V14.9085H10.75V7.49316Z",
    fill: "#455079"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59466 14.8851L8.32333 7.46973L7.07067 7.51573L7.342 14.9311L8.59466 14.8851Z",
    fill: "#455079"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 4.40137V5.6547H3.97267L5.00867 17.4274C5.02234 17.5835 5.09398 17.7288 5.20949 17.8347C5.325 17.9405 5.47597 17.9993 5.63267 17.9994H14.5933C14.75 17.9993 14.901 17.9405 15.0165 17.8347C15.132 17.7288 15.2037 17.5835 15.2173 17.4274L16.2533 5.6547H17.58V4.40137H2.66667ZM14.0193 16.746H6.20667L5.23067 5.6547H14.9953L14.0193 16.746Z",
    fill: "#455079"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1707 2H8.07667C7.79966 2.00018 7.53405 2.1103 7.33818 2.30617C7.1423 2.50205 7.03218 2.76766 7.032 3.04467V5.02867H8.28533V3.25333H11.9613V5.02867H13.2147V3.04467C13.2145 2.76777 13.1045 2.50226 12.9087 2.30641C12.713 2.11055 12.4476 2.00035 12.1707 2V2Z",
    fill: "#455079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.7f65bf3739cbf0a925495683790c4458.svg";
export { ForwardRef as ReactComponent };